export default __webpack_public_path__ + "static/media/hamburger-menu-16x16.34348f64.svg";